module.exports = __webpack_public_path__ + "img/cropped-kitkit-phase3_icon-192x192.e23a133e.png";